var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.02943 8.5L7.02943 2.4365C7.02943 2.0309 7.48693 1.79408 7.8181 2.02825L16.3932 8.09175C16.675 8.29099 16.675 8.70901 16.3932 8.90825L7.8181 14.9718C7.48693 15.2059 7.02943 14.9691 7.02943 14.5635L7.02943 8.5Z","fill":"#242424"}));
}

Play.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Play;

Play.default = Play;
